"use client";

import { GoBack } from "./navigation/go-back";
import { NavItem } from "./navigation/nav-item";
import { NavLogo } from "./navigation/nav-logo";
import { NavigationBar } from "./navigation/navigation-bar";

type NavProps = {
  onGoBack?: () => void;
  className?: string;
  variant?: "default" | "floating";
};

export function Nav({ onGoBack, className, variant = "default" }: NavProps) {
  return (
    <NavigationBar
      variant={variant}
      className={className}
      rightSection={
        onGoBack && (
          <NavItem align="left">
            <GoBack onClick={onGoBack} size="md" />
          </NavItem>
        )
      }
      leftSection={
        <NavItem align="center">
          <NavLogo />
        </NavItem>
      }
    />
  );
}
